import type { CellUpdate } from "./useCellSaver";

// User edits from the daily grid (typed, pasted, range-filled) become cell
// updates. A number is a deliberate value and gets the manual flag so
// Distribute keeps it — including a typed 0. null means the user cleared the
// cell: saved as 0 without the flag, so Distribute can fill it again.
export function toCellUpdates(
  productExternalId: string,
  updates: { period_date: string; quantity: number | null }[],
): CellUpdate[] {
  return updates.map((u) => ({
    product_external_id: productExternalId,
    period_date: u.period_date,
    quantity: u.quantity ?? 0,
    manual: u.quantity !== null,
  }));
}
